module.exports = __webpack_public_path__ + "static/media/map-animation-play.104650be.svg";